<template>
  <el-dialog
    class="importError"
    title="导入失败"
    :visible.sync="dialog"
    :before-close="notBtn"
    :close-on-click-modal="false"
    width="600px"
  >
    <el-table :data="tableErrorData" style="width: 100%;">
      <el-table-column type="index" width="80"></el-table-column>
      <el-table-column prop="errorRecord" label="失败记录"></el-table-column>
      <el-table-column prop="errorMsg" label="失败原因"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  name: 'ImportError',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    tableErrorData: {
      type: Array
    }
  },
  methods: {
    notBtn() {
      this.$emit('update:dialog', false)
    }
  }
}
</script>

<style lang="less" scoped>
.importError {
  /deep/ .el-dialog {
    border-radius: 4px;
    .el-dialog__title {
      font-weight: bold;
    }
    .el-table__header {
      width: 100% !important;
    }
    .el-table__body {
      width: 100% !important;
      max-height: 400px;
      overflow-y: auto;
    }
  }
}
</style>
